import React from 'react';
import { useNavigate } from 'react-router-dom';

const MarketplaceFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#0B1220] border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div>
            <p className="text-white/60 text-sm">
              © 2024 First On Date. All integrations tested and verified.
            </p>
          </div>
          <div className="flex gap-6">
            <button onClick={() => navigate('/enterprise-landing-page')} className="text-white/60 hover:text-[#FFD100] text-sm transition-colors">
              Home
            </button>
            <button onClick={() => navigate('/documentation')} className="text-white/60 hover:text-[#FFD100] text-sm transition-colors">
              Documentation
            </button>
            <button onClick={() => navigate('/api')} className="text-white/60 hover:text-[#FFD100] text-sm transition-colors">
              API
            </button>
            <button onClick={() => navigate('/contact')} className="text-white/60 hover:text-[#FFD100] text-sm transition-colors">
              Support
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MarketplaceFooter;